import React, { memo, useEffect, useState } from "react";
import styled from "styled-components";
import { selectionStore } from "../../../stores/selection.store";
import { SelectionGuests } from "./selection-guests";
import { moduleSettings } from "../../../stores/module-settings.store";
import { selectionStoreChangesService } from "../../../services/selection-store-changes.service";
import { GolEventListener } from "../../calendar/calendar";

const SelectionPaxWrapper = styled.div``;

const Pax = () => {
  const [, setSelectedGuests] = useState(selectionStore.guests);
  const childrenManagementEnabled = moduleSettings.childrenManagementEnabled;

  useEffect(() => {
    selectionStoreChangesService.registerListener(
      "pax",
      [GolEventListener.Guests],
      () => {
        setSelectedGuests(selectionStore.guests);
      }
    );
    return () => {
      selectionStoreChangesService.unregisterListener("pax");
    };
  }, []);

  return (
    <SelectionPaxWrapper data-test="selection-pax" id="selection-pax">
      <SelectionGuests
        type={childrenManagementEnabled ? "adults" : "persons"}
      />
      {childrenManagementEnabled && <SelectionGuests type="children" />}
    </SelectionPaxWrapper>
  );
};

export const SelectionPax = memo(Pax);
